import React from 'react';
import { useConfig } from 'hook/config.hook';
import './DateText.scss';

function DateText({ datatestid, date, label, ...props }) {
  const { config } = useConfig();
  return (
    <div {...props} className="datetext-container">
      <div
        className="datetext-date"
        data-testid={datatestid ? `${datatestid}-date` : null}
      >
        {date}
      </div>
      <div
        className="datetext-text"
        data-testid={datatestid ? `${datatestid}-avgage-text` : null}
      >
        {' '}
        {config?.dateText?.title}
      </div>
    </div>
  );
}

export { DateText };
